import { logout } from '../store/slices/authSlice';
import axios from 'axios';
import { endpoints } from '../api/apis';
import { store,persistor } from '../store/newstore';
import { Platform } from 'react-native';
import AsyncStorage from '@react-native-async-storage/async-storage';
import { resetPartnerParams } from '../store/slices/platformSlice';
import { removeFCMTokenAndUpdateServer, trackEvent } from '@app/utils';
import { clearCommonStore } from '@app/store/slices/commonSlice';
import { clearFeatureFlags } from '@app/services/featureFlag';
import * as Sentry from '@sentry/react-native';

function deleteCookie(cookieName) {
  if(cookieName === 'access_token' && window.location.protocol === 'https:'){
  document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; SameSite=None; Secure;`
  }else{
    document.cookie = `${cookieName}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/;Max-Age=-1;`;
  }
}

export function deleteAllCookies() {
  // Split document.cookie into individual cookies
  const cookies = document.cookie.split(';');

  // Loop through all cookies and delete them
  for (let i = 0; i < cookies.length; i++) {
    const cookieName = cookies[i].split('=')[0].trim();
    deleteCookie(cookieName);
  }
}


/**
 * Clears all keys from AsyncStorage except the ones specified in the whitelist.
 * @param whitelist - Array of keys to keep in AsyncStorage.
 * @returns Promise<void>
 */
export const clearAsyncStorageExcept = async (whitelist: string[]): Promise<void> => {
  try {
    // Get all keys in AsyncStorage
    const allKeys: string[] = await AsyncStorage.getAllKeys();

    // Filter out the keys that are in the whitelist
    const keysToDelete: string[] = allKeys.filter((key) => !whitelist.includes(key));

    // Clear only the non-whitelisted keys
    if (keysToDelete.length > 0) {
      await AsyncStorage.multiRemove(keysToDelete);
    }

    console.log('AsyncStorage cleared except for:', whitelist);
  } catch (error) {
    console.error('Error while clearing AsyncStorage:', error);
  }
};


const LogOutUser = async () => {
  await removeFCMTokenAndUpdateServer()
  trackEvent('USER_PROFILE_LOGOUT_POPUP_YES_CLICKED')
  const url = endpoints.logout;
  if(axios.defaults.headers.common.Authorization){
    axios.post(url, {});
  }
  delete axios.defaults.headers.common.Authorization;
  await AsyncStorage.removeItem("applicationState")
  await clearAsyncStorageExcept(['first_time', 'show_new_arch','show_lms_revamp', 'remoteConfig', 'biometric_permission'])
  store.dispatch(logout());
  store.dispatch(resetPartnerParams());
  store.dispatch(clearCommonStore())
  store.dispatch(clearFeatureFlags());
  persistor.purge();
  Sentry?.setUser(null);
  if (Platform.OS === 'web') {
    // localStorage.clear();
    deleteAllCookies();
    // let currentUrl = window.location.href;
    // Remove the URL parameters (everything after '?')
    // let cleanUrl = currentUrl.split('?')[0];

    // Replace the current history state without reloading the page
    // window?.history?.replaceState(null, null, cleanUrl);
    // window.location.reload()
  }
};

export const LogOutUserWithoutResetPartnerParams = async () => {
  await removeFCMTokenAndUpdateServer()
  trackEvent('USER_LOGGED_OUT')
  const url = endpoints.logout;
  if(axios.defaults.headers.common.Authorization){
    axios.post(url, {});
  }
  delete axios.defaults.headers.common.Authorization;
  await AsyncStorage.removeItem("applicationState")
  await clearAsyncStorageExcept(['first_time', 'show_new_arch','show_lms_revamp', 'remoteConfig', 'biometric_permission'])
  store.dispatch(logout());
  store.dispatch(clearCommonStore())
  store.dispatch(clearFeatureFlags());
  persistor.purge();
  if (Platform.OS === 'web') {
    // localStorage.clear();
    deleteAllCookies();
    // let currentUrl = window.location.href;
    // Remove the URL parameters (everything after '?')
    // let cleanUrl = currentUrl.split('?')[0];

    // Replace the current history state without reloading the page
    // window?.history?.replaceState(null, null, cleanUrl);
    // window.location.reload()
  }
}

export default LogOutUser;
